import { getUserRoles } from "./common";

/**
 * IMPORTANT: please check leak detection response form fields & WhenFieldChanges component
 * in release-incident-screens.js before modifying the data
 *
 * WhenFieldChanges is a component of React-final-form
 */
export const autoUpdateUOMFields = [
  {
    id: 1,
    unit: "bph",
    set: "estMaximumUnit",
  },
  {
    id: 2,
    unit: "m3/h",
    set: "estMaximumUnit",
  },
  {
    id: 3,
    unit: "",
    set: "estMaximumUnit",
  },
  {
    id: 4,
    unit: "N/A",
    set: "estMaximumUnit",
  },
  {
    id: 5,
    unit: "bph",
    set: "estMinimumUnit",
  },
  {
    id: 6,
    unit: "m3/h",
    set: "estMinimumUnit",
  },
  {
    id: 7,
    unit: "",
    set: "estMinimumUnit",
  },
  {
    id: 8,
    unit: "N/A",
    set: "estMinimumUnit",
  },
  {
    id: 9,
    unit: "bph",
    set: "leakDetections[0].uom",
  },
  {
    id: 10,
    unit: "bph",
    set: "leakDetections[1].uom",
  },
  {
    id: 11,
    unit: "bph",
    set: "leakDetections[2].uom",
  },
  {
    id: 12,
    unit: "bph",
    set: "leakDetections[3].uom",
  },
  {
    id: 13,
    unit: "bph",
    set: "leakDetections[4].uom",
  },
  {
    id: 14,
    unit: "bph",
    set: "leakDetections[5].uom",
  },
  {
    id: 15,
    unit: "bph",
    set: "leakDetections[6].uom",
  },
  {
    id: 16,
    unit: "bph",
    set: "leakDetections[7].uom",
  },
  {
    id: 17,
    unit: "bph",
    set: "leakDetections[8].uom",
  },
  {
    id: 18,
    unit: "bph",
    set: "leakDetections[9].uom",
  },
  {
    id: 19,
    unit: "bph",
    set: "leakDetections[10].uom",
  },
  {
    id: 20,
    unit: "m3/h",
    set: "leakDetections[0].uom",
  },
  {
    id: 21,
    unit: "m3/h",
    set: "leakDetections[1].uom",
  },
  {
    id: 22,
    unit: "m3/h",
    set: "leakDetections[2].uom",
  },
  {
    id: 23,
    unit: "m3/h",
    set: "leakDetections[3].uom",
  },
  {
    id: 24,
    unit: "m3/h",
    set: "leakDetections[4].uom",
  },
  {
    id: 25,
    unit: "m3/h",
    set: "leakDetections[5].uom",
  },
  {
    id: 26,
    unit: "m3/h",
    set: "leakDetections[6].uom",
  },
  {
    id: 27,
    unit: "m3/h",
    set: "leakDetections[7].uom",
  },
  {
    id: 28,
    unit: "m3/h",
    set: "leakDetections[8].uom",
  },
  {
    id: 29,
    unit: "m3/h",
    set: "leakDetections[9].uom",
  },
  {
    id: 30,
    unit: "m3/h",
    set: "leakDetections[10].uom",
  },
  {
    id: 31,
    unit: "",
    set: "leakDetections[0].uom",
  },
  {
    id: 32,
    unit: "",
    set: "leakDetections[1].uom",
  },
  {
    id: 33,
    unit: "",
    set: "leakDetections[2].uom",
  },
  {
    id: 34,
    unit: "",
    set: "leakDetections[3].uom",
  },
  {
    id: 35,
    unit: "",
    set: "leakDetections[4].uom",
  },
  {
    id: 36,
    unit: "",
    set: "leakDetections[5].uom",
  },
  {
    id: 37,
    unit: "",
    set: "leakDetections[6].uom",
  },
  {
    id: 38,
    unit: "",
    set: "leakDetections[7].uom",
  },
  {
    id: 39,
    unit: "",
    set: "leakDetections[8].uom",
  },
  {
    id: 40,
    unit: "",
    set: "leakDetections[9].uom",
  },
  {
    id: 41,
    unit: "",
    set: "leakDetections[10].uom",
  },
  {
    id: 42,
    unit: "N/A",
    set: "leakDetections[0].uom",
  },
  {
    id: 43,
    unit: "N/A",
    set: "leakDetections[1].uom",
  },
  {
    id: 44,
    unit: "N/A",
    set: "leakDetections[2].uom",
  },
  {
    id: 45,
    unit: "N/A",
    set: "leakDetections[3].uom",
  },
  {
    id: 46,
    unit: "N/A",
    set: "leakDetections[4].uom",
  },
  {
    id: 47,
    unit: "N/A",
    set: "leakDetections[5].uom",
  },
  {
    id: 48,
    unit: "N/A",
    set: "leakDetections[6].uom",
  },
  {
    id: 49,
    unit: "N/A",
    set: "leakDetections[7].uom",
  },
  {
    id: 50,
    unit: "N/A",
    set: "leakDetections[8].uom",
  },
  {
    id: 51,
    unit: "N/A",
    set: "leakDetections[9].uom",
  },
  {
    id: 52,
    unit: "N/A",
    set: "leakDetections[10].uom",
  },
];

export const REQUIRED = "Required";

// generate required error for leak detection systems accuracy & swiftness perfomance fields
function generateLeakDetectionErrors(
  expectedSwiftnessIsRequired,
  indicatedAvgLeakRateIsRequired,
  operationIsRequired,
  detectedIsRequired
) {
  const requiredFields = {};

  if (expectedSwiftnessIsRequired) {
    requiredFields.expectedSwiftness = REQUIRED;
  }
  if (indicatedAvgLeakRateIsRequired) {
    requiredFields.indicatedAvgLeakRate = REQUIRED;
  }
  if (operationIsRequired) {
    requiredFields.operation = REQUIRED;
  }
  if (detectedIsRequired) {
    requiredFields.detected = REQUIRED;
  }

  return requiredFields;
}

/* Validate form fields */
export const validate = (values) => {
  const errors = {};
  const leakDetections = [];

  // no selection in estimatedAvgLeakRateSelect & in estimatedLeakRate input - new record
  if (
    values.estimatedAvgLeakRateSelect === null &&
    (values.estimatedAvgLeakRate === null ||
      values.estimatedAvgLeakRate === "" ||
      values.estimatedAvgLeakRate)
  ) {
    errors.estimatedAvgLeakRateSelect = REQUIRED;
    errors.estimatedAvgLeakRate = REQUIRED;
  }
  // estimatedAvgLeakRateSelect has N/A & estimatedAvgLeakRate input is blank
  if (
    values.estimatedAvgLeakRateSelect !== "N/A" &&
    (values.estimatedAvgLeakRate < 0 ||
      values.estimatedAvgLeakRate === null ||
      values.estimatedAvgLeakRate === "")
  ) {
    errors.estimatedAvgLeakRate = REQUIRED;
  }

  /**
   *  Validation errors in (Leak Detection Systems Accuracy and Swiftness Performance) Table and
   * in Leak Detection Systems Reliability Performance Table
   * Here if UOM column is not N/A then display Required for Indicated Avg Leak Rate as well as for
   * expected swiftness and
   * if yes/no/na is not selected for operation & detected in Leak Detection Systems Reliability
   * Performance Table then display Requred
   */
  if (values?.leakDetections?.length) {
    values.leakDetections.forEach((item, index) => {
      let expectedSwiftnessIsRequired = false;
      let indicatedAvgLeakRateIsRequired = false;
      let operationIsRequired = false;
      let detectedIsRequired = false;
      if (item.uom !== "N/A") {
        if (item.expectedSwiftness === null || item.expectedSwiftness === "") {
          errors[`leakDetections[${index}].expectedSwiftness`] = REQUIRED;
          expectedSwiftnessIsRequired = true;
        }
        if (
          item.indicatedAvgLeakRate === null ||
          item.indicatedAvgLeakRate === ""
        ) {
          errors[`leakDetections[${index}].indicatedAvgLeakRate`] = REQUIRED;
          indicatedAvgLeakRateIsRequired = true;
        }
      }

      if (
        item.operation === null ||
        item.operation === "" ||
        !item.hasOwnProperty("operation")
      ) {
        errors[`leakDetections[${index}].operation`] = REQUIRED;
        operationIsRequired = true;
      }

      if (
        item.detected === null ||
        item.detected === "" ||
        !item.hasOwnProperty("detected")
      ) {
        errors[`leakDetections[${index}].detected`] = REQUIRED;
        detectedIsRequired = true;
      }

      leakDetections.splice(
        index,
        0,
        generateLeakDetectionErrors(
          expectedSwiftnessIsRequired,
          indicatedAvgLeakRateIsRequired,
          operationIsRequired,
          detectedIsRequired
        )
      );
    });
  }
  errors.leakDetections = leakDetections;
  return errors;
};

// checks whether user contains read only role & returns in boolean format
export const isReadWriteRole = () => {
  const roleObj = getUserRoles()
  return roleObj.roles.includes("ReleaseIncidentReadWrite")
}
